import moment from 'moment';
import 'moment/locale/es';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const TIME_FORMAT = 'HH:mm';
export const YMD_FORMAT = 'YYYY-MM-DD';
const YMDHMS_FORMAT = 'YYYY-MM-DD_HH-mm-ss';

export const parseDate_DayOfTheWeek = date => {
  let parsedDate = moment(date).locale('es').format('dddd');
  return parsedDate.replace(/^\w/, c => c.toUpperCase());
};

export const parseDate_DDMM = date => {
  return moment(date).locale('es').format('DD/MM');
};

export const parseDate_DayDDMM = (date, shortDay) => {
  let parsedDate = moment(date)
    .locale('es')
    .format(`${shortDay ? 'ddd' : 'dddd'} DD/MM`);
  return parsedDate.replace(/^\w/, c => c.toUpperCase());
};

export const parseDate_ShortDayDDMM = date => {
  return parseDate_DayDDMM(date, true).replace('.', '');
};

export const parseDate_HHmm = date => {
  return moment(date).format('HH:mm');
};

export const currentDateStr = () => {
  return moment().format(DATE_FORMAT);
};

export const currentTimeStr = () => {
  return moment().format(TIME_FORMAT);
};

export const nextDateStr = dateStr => {
  return dateToStr(moment(dateStr, DATE_FORMAT).add(1, 'days'));
};

export const dateToStr = date => {
  return moment(date).format(DATE_FORMAT);
};

export const strToDate = dateStr => {
  return moment(dateStr, DATE_FORMAT);
};

export const todayLastYearDate = () => {
  return moment().subtract(1, 'year').add(1, 'day');
};

export const todayDate = () => {
  return moment().format(YMD_FORMAT);
};

export const todayLastYear = () => {
  return todayLastYearDate().format(YMD_FORMAT);
};

export const firstDayPastYear = () => {
  return moment().subtract(1, 'year').startOf('year').format(YMD_FORMAT);
};

export const lastTwoMonth = () => {
  return moment().subtract(60, 'days').format(YMD_FORMAT);
};

export const firstDayMonth = () => {
  return moment().startOf('month');
};

export const currentDateForFile = () => {
  return moment().format(YMDHMS_FORMAT);
};
// export const dateToPhrase = (date = new Date()) => {
//   const completeDateStr = moment(date).locale('es').format('DD [de] MMMM');
//   const dateStrParts = completeDateStr.split(' ');
//   dateStrParts[0] = parseInt(dateStrParts[0]);
//   dateStrParts[2] = toTitleCase(dateStrParts[2]);

//   return dateStrParts.join(' ');
// };
